/*Customizations:
- pass all new parameters to CardWithImageTemplate
*/
import React from 'react';
import CardWithImageTemplate from 'design-comuni-plone-theme/components/ItaliaTheme/Blocks/Listing/CardWithImageTemplate';
const RenderItems = (props) => {
  return <CardWithImageTemplate {...props} />;
};
export default RenderItems;
